import Component from "@glimmer/component";
import { service } from "@ember/service";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { arrayOf, instanceOf } from "prop-types";
import OrganizationModel from "glesys-controlpanel/models/organization";

@forbidExtraArgs
export default class Sidebar extends Component {
  @service session;
  @service current;
  @service router;

  @arg(arrayOf(instanceOf(OrganizationModel)).isRequired) organizations;

  get organization() {
    return this.current.organization;
  }

  get project() {
    return this.current.project;
  }
}
